import React, { useState } from 'react';
import SnookerRefereeDesk from './SnookerRefereeDesk';

const PoolRefereeControls = React.memo(({ gameState, settings, game, type, switchPlayer, startShotTimer, stopShotTimer, extendShotTimer, startTimer, pauseTimer, resetTimer, winFrame, resetFrames, addIllegalBreak, undoAction, formatShotTime, getFlagComponent, resetShotTimer, forceSync }) => {
    const [confirmDialog, setConfirmDialog] = useState({ show: false, action: null, message: '' });

    const handleWinFrame = () => {
        setConfirmDialog({
            show: true,
            action: 'winFrame',
            message: 'Are you sure you want to win this frame?'
        });
    };
    const handleResetFrames = () => {
        setConfirmDialog({
            show: true,
            action: 'resetFrames',
            message: 'Are you sure you want to reset all frames?'
        });
    };
    const confirmAction = () => {
        if (confirmDialog.action === 'winFrame') {
            winFrame();
        } else if (confirmDialog.action === 'resetFrames') {
            resetFrames();
        }
        setConfirmDialog({ show: false, action: null, message: '' });
    };
    const cancelAction = () => {
        setConfirmDialog({ show: false, action: null, message: '' });
    };

    const renderControlButtons = () => {
        return (
            <>
                <button onClick={startTimer} style={buttonStyle}>
                    <div style={{ ...buttonIconStyle, background: '#28a745' }}>▶</div>
                    <div style={buttonLabelStyle}>START TIMER</div>
                </button>
                <button onClick={pauseTimer} style={buttonStyle}>
                    <div style={{ ...buttonIconStyle, background: '#ffc107' }}>⏸</div>
                    <div style={buttonLabelStyle}>PAUSE TIMER</div>
                </button>
                <button onClick={resetTimer} style={buttonStyle}>
                    <div style={{ ...buttonIconStyle, background: '#17a2b8' }}>⏹</div>
                    <div style={buttonLabelStyle}>RESET TIMER</div>
                </button>
                <button onClick={undoAction} style={buttonStyle}>
                    <div style={{ ...buttonIconStyle, background: '#6c757d' }}>↩</div>
                    <div style={buttonLabelStyle}>UNDO</div>
                </button>
                <button onClick={startShotTimer} style={buttonStyle} disabled={gameState.isGameFinished || settings[`${type.replace('-', '_')}_shot_timer_enabled`] !== 'true'}>
                    <div style={{ ...buttonIconStyle, background: '#28a745' }}>ST</div>
                    <div style={buttonLabelStyle}>START SHOT</div>
                </button>
                <button onClick={stopShotTimer} style={buttonStyle} disabled={gameState.isGameFinished || settings[`${type.replace('-', '_')}_shot_timer_enabled`] !== 'true'}>
                    <div style={{ ...buttonIconStyle, background: '#dc3545' }}>SP</div>
                    <div style={buttonLabelStyle}>STOP SHOT</div>
                </button>
                <button onClick={resetShotTimer} style={buttonStyle} disabled={gameState.isGameFinished || settings[`${type.replace('-', '_')}_shot_timer_enabled`] !== 'true'}>
                    <div style={{ ...buttonIconStyle, background: '#dc3545' }}>RS</div>
                    <div style={buttonLabelStyle}>RESET SHOT</div>
                </button>
                <button
                    onClick={extendShotTimer}
                    style={buttonStyle}
                    disabled={
                        gameState.isGameFinished ||
                        settings[`${type.replace('-', '_')}_shot_timer_enabled`] !== 'true' ||
                        (gameState.currentPlayer === 1 ? gameState.player1ExtensionUsed : gameState.player2ExtensionUsed)
                    }
                >
                    <div style={{ ...buttonIconStyle, background: '#fd7e14' }}>EX</div>
                    <div style={buttonLabelStyle}>EXTEND</div>
                </button>
                <button onClick={switchPlayer} style={buttonStyle}>
                    <div style={{ ...buttonIconStyle, background: '#6f42c1' }}>🔄</div>
                    <div style={buttonLabelStyle}>SWITCH</div>
                </button>
                {type === 'chinese-pool' ? (
                    <button onClick={addIllegalBreak} style={buttonStyle}>
                        <div style={{ ...buttonIconStyle, background: '#dc3545' }}>IB</div>
                        <div style={buttonLabelStyle}>ILLEGAL BREAK</div>
                    </button>
                ) : <div></div>}
                <div></div>
                <div></div>
                <div></div>
                <button onClick={handleWinFrame} style={{ ...buttonStyle, gridColumn: 'span 2' }}>
                    <div style={{ ...buttonIconStyle, background: '#28a745' }}>W</div>
                    <div style={buttonLabelStyle}>WIN FRAME</div>
                </button>
                <button onClick={handleResetFrames} style={{ ...buttonStyle, gridColumn: 'span 2' }}>
                    <div style={{ ...buttonIconStyle, background: '#dc3545' }}>R</div>
                    <div style={buttonLabelStyle}>RESET FRAMES</div>
                </button>
                <button onClick={forceSync} style={{ ...buttonStyle, gridColumn: 'span 4' }}>
                    <div style={{ ...buttonIconStyle, background: '#6c757d' }}>🔄</div>
                    <div style={buttonLabelStyle}>FORCE SYNC (ALL DEVICES)</div>
                </button>
            </>
        );
    };

    const renderScoreDisplay = () => {
        return (
            <>
                {type === 'chinese-pool' && (
                    <div className="player-illegal-breaks" style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                        {[...Array(3)].map((_, index) => (
                            <span
                                key={`p1-break-${index}`}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: index < gameState.player1IllegalBreaks ? '#ff4d4f' : '#4a4a4a',
                                    transition: 'background-color 0.3s ease'
                                }}
                            ></span>
                        ))}
                    </div>
                )}
                <div style={{ background: '#4169e1', color: 'white', padding: '8px 16px', fontSize: '24px', fontWeight: 'bold', borderRadius: '0px', height: 67, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 120, position: 'relative', margin: '0 10px' }}>
                    {gameState.player1FramesWon} - {gameState.player2FramesWon}
                    <span style={{ backgroundColor: '#fff', color: 'black', fontSize: '12px', width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '100%', left: 0, height: 40 }}>
                        <span>{gameState.shotTimeRemaining > 0 ? formatShotTime(gameState.shotTimeRemaining) : '--:--'}</span>
                    </span>
                </div>
                {type === 'chinese-pool' && (
                    <div className="player-illegal-breaks" style={{ display: 'flex', gap: '5px', marginRight: '10px' }}>
                        {[...Array(3)].map((_, index) => (
                            <span
                                key={`p2-break-${index}`}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: index < gameState.player2IllegalBreaks ? '#ff4d4f' : '#4a4a4a',
                                    transition: 'background-color 0.3s ease'
                                }}
                            ></span>
                        ))}
                    </div>
                )}
            </>
        );
    };

    const displayTime = gameState.time;

    return (
        <div style={{ width: '100vw', height: '100vh', background: '#2c2c2c', margin: 0, padding: 0, fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column' }}>
            {confirmDialog.show && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        background: '#333',
                        padding: '30px',
                        borderRadius: '10px',
                        border: '2px solid #555',
                        maxWidth: '400px',
                        textAlign: 'center'
                    }}>
                        <div style={{ color: 'white', fontSize: '18px', marginBottom: '30px' }}>
                            {confirmDialog.message}
                        </div>
                        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                            <button
                                onClick={confirmAction}
                                style={{
                                    ...buttonStyle,
                                    padding: '15px 30px',
                                    minHeight: 'auto'
                                }}
                            >
                                <div style={buttonLabelStyle}>YES</div>
                            </button>
                            <button
                                onClick={cancelAction}
                                style={{
                                    ...buttonStyle,
                                    padding: '15px 30px',
                                    minHeight: 'auto',
                                    borderColor: '#dc3545'
                                }}
                            >
                                <div style={buttonLabelStyle}>NO</div>
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ width: '100%', background: '#f8b500', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '150px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '10px', paddingRight: '10px', position: 'relative' }}>
                        {game && game.has_flags !== '0' && (
                            <div style={{ width: '30px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>
                                {getFlagComponent(gameState.firstPlayerNationality)}
                            </div>
                        )}
                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>
                            {gameState.firstPlayer}
                        </div>
                        {gameState.currentPlayer === 1 && (
                            <div style={{ position: 'absolute', right: '-30px', width: 0, height: 0, borderTop: '10px solid transparent', borderBottom: '10px solid transparent', borderLeft: '20px solid #000', zIndex: 10 }}></div>
                        )}
                    </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                        {renderScoreDisplay()}
                    </div>
                    <div style={{ width: '150px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '10px', paddingRight: '10px', position: 'relative' }}>
                        {gameState.currentPlayer === 2 && (
                            <div style={{ position: 'absolute', left: '-30px', width: 0, height: 0, borderTop: '10px solid transparent', borderBottom: '10px solid transparent', borderRight: '20px solid #000', zIndex: 10 }}></div>
                        )}
                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>
                            {gameState.secondPlayer}
                        </div>
                        {game && game.has_flags !== '0' && (
                            <div style={{ width: '30px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '12px' }}>
                                {getFlagComponent(gameState.secondPlayerNationality)}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ background: '#000000b3', color: 'white', fontSize: '12px', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', height: 50 }}>
                    {displayTime}
                </div>
            </div>
            <div style={{ background: '#1a1a1a', padding: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', maxWidth: '400px', width: '100%' }}>
                    {renderControlButtons()}
                </div>
            </div>
        </div>
    );
});

const buttonStyle = {
    background: '#333',
    border: '2px solid #555',
    borderRadius: '10px',
    padding: '10px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    transition: 'all 0.2s',
    minHeight: '70px',
    color: 'white'
};
const buttonIconStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'white'
};
const buttonLabelStyle = {
    fontSize: '10px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#ccc'
};

// Pool referee screens retain their existing controls; the snooker desk is
// isolated so its layout and confirmations cannot change pool scoring.
export default React.memo(props => props.type === 'snooker'
    ? <SnookerRefereeDesk {...props} />
    : <PoolRefereeControls {...props} />);
